export default __webpack_public_path__ + "static/media/purple-blob.6857f9ff.svg";